import { HttpContextToken } from "@angular/common/http";

// Context token to allow components to skip global error handling
export const SKIP_GLOBAL_ERROR = new HttpContextToken<boolean>(() => false);

// Context token to control whether to show actual backend error messages or generic ones
export const SHOW_BACKEND_ERROR_MESSAGE = new HttpContextToken<boolean>(
  () => true
);
